import {Job} from "../../api/types";
import {useEffect, useState} from "react";
import {agent} from "../../api/agent";
import {useSearchParams} from "react-router-dom";
import JobList from "./JobList";
import JobDetails from "./details/JobDetails";
import Loading from "../Loading";

export default function Jobs() {

    const [selectedRepo, setSelectedRepo] = useState<string | null>(null);
    const [searchParameters, setSearchParameters] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        if (searchParameters.has('repo')) {
            const repo = searchParameters.get('repo');
            if (repo) {
                setSelectedRepo(repo);
                setLoading(false);
            } else {
                setSelectedRepo(null);
                setLoading(false);
            }
        }else{
            setSelectedRepo(null);
            setLoading(false);
        }
    }, [searchParameters]);

    return (<>
        <Loading open={loading}></Loading>
        {!loading && !selectedRepo && (<JobList></JobList>)}
        {!loading && selectedRepo && (<JobDetails repo={selectedRepo}></JobDetails>)}
    </>);
}